import {
  getDisposal,
  getInstallation,
  isInstallationAvailable,
  isDisposalAvailable,
  isDeliveryAvailable,
  getDelivery,
} from '@additional-services/store/selectors/services.selector';
import {
  isDisposalSelected,
  isInstallationSelected,
  isDeliverySelected,
} from '@additional-services/store/selectors/extras.selector';
import { Offer, Offers } from '@dgx-pr-spa/shared/util';
import {
  getOffer,
  getOffers,
} from '@view-offers/store/selectors/offers.selector';
import { InstallationDisposal } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Service } from '@dgx-pr-spa/shared/util';
import { getSelectedOffer } from '@product-details/store/selectors/selected.selector';
import { getCostSummary } from './cost.summary.selector';
import { CostSummary } from '@dgx-pr-spa/shared/util';
import { createSelector } from '@ngrx/store';
import { offersType } from '@shared/helpers/function.helpers';

export const installationDisposalData = createSelector(
  [
    isInstallationSelected,
    isInstallationAvailable,
    getInstallation,
    isDisposalSelected,
    isDisposalAvailable,
    getDisposal,
  ],
  (
    instSel: boolean,
    instAvail: boolean,
    inst: Service,
    dispSel: boolean,
    dispAvail: boolean,
    disp: Service
  ) => ({
    isInstallationSelected: instSel,
    isInstallationAvailable: instAvail,
    installation: inst,
    isDisposalSelected: dispSel,
    isDisposalAvailable: dispAvail,
    disposal: disp,
  })
);

export const getUpfrontPaymentArgs = createSelector(
  [
    getCostSummary,
    getSelectedOffer,
    installationDisposalData,
    getOffer,
    isDeliveryAvailable,
    isDeliverySelected,
    getDelivery,
    getOffers,
  ],
  (
    costSummary: CostSummary,
    selected: ReplacementOffer,
    instDispData: InstallationDisposal,
    offer = {} as Offer,
    deliveryAvailable,
    deliverySelected,
    delivery,
    offers
  ) => {
    const { isProtectionSelected, monthlyPayment, replacementCost } =
      costSummary;

    return {
      make: selected?.make,
      model: selected?.model,
      applianceCategory: selected?.appliance_category,
      upgradeFee: selected?.upgrade_fee,
      isProtectionSelected,
      monthlyPayment,
      replacementCost,
      isInstallationSelected: instDispData?.isInstallationSelected,
      isInstallationAvailable: instDispData?.isInstallationAvailable,
      installation: instDispData?.installation,
      isDisposalSelected: instDispData?.isDisposalSelected,
      isDisposalAvailable: instDispData?.isDisposalAvailable,
      disposal: instDispData?.disposal,
      isDeliveryAvailable: deliveryAvailable,
      isDeliverySelected: deliverySelected,
      delivery,
      outstandingMonthlyPayments: (offer as Offer)?.outstanding_dd_count,
      outstandingPlanAmount: (offer as Offer)?.outstanding_dd_amount,
      jobReferenceNumber: (offers as Offers)?.current_plan?.reference_number,
      offerType: offersType(offers as Offers)?.toString(),
    };
  }
);
